<template>
  <div class="courser-box">
    <div class="courser-card" v-for="(item, index) of list" :key="index">
      <template v-if="item.courseListList.length > 0">
        <div class="home2-title">
          <span>{{ item.cateName }}</span>
          <div class="title-cate">
            <a
              v-for="(item2, index2) of item.courseSubList"
              :key="index2"
              :href="
                '#/publicCourse?parentId=' +
                item.cateId +
                '&childId=' +
                item2.cateId
              "
            >{{ item2.cateName }}</a>
          </div>
          <a :href="'#/publicCourse?parentId=' + item.cateId" class="more">查看更多</a>
        </div>
        <div class="courser-content">
          <div class="courser-carder" v-for="(item3, index3) of item.courseListList" :key="index3">
            <div class="card-main" v-show="item3.ccIdCount>0" @click="GotoCourseDetail(item3.courseId, item3.packagebagId)">
              <!-- <img :src="item3.coursePic" alt="" /> -->
              <el-image :src="item3.coursePic" lazy></el-image>
              <div class="title">{{ item3.courseName }}</div>
              <div class="bottom">
                <p>视频数：{{ item3.ccIdCount }}</p>
                <p>浏览量：{{ item3.courseClickRate }}</p>
              </div>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { deepClone } from "@/utils/index";
import { getCourseHomeList } from "@/apiCloud/CateSelect";
export default {
  props: {
    width: {
      type: String,
      default: "338px"
    }
  },
  data() {
    return {
      activeIndex: 0,
      catePartShow: false,
      list: [],
      partList: [],
      curTitle: "",
      courseType: ""
    };
  },
  created() {
    this.getList();
  },
  methods: {
    // 获取课程数据
    getList() {
      getCourseHomeList({ courseSource: 0, pageSize: 1000, pageNum: 1 }).then(
        res => {
          if (res.code == 200) {
            // res.data = res.data.filter(fitem=>fitem.ccIdCount>0)
            //   按课程数量排序
            res.data = res.data.sort(function(a, b) {
              return b.courseListList.length - a.courseListList.length;
            });
            // console.log(res.data);
            res.data.forEach((item, index) => {
              // 取前8个
              res.data[index].courseListList = res.data[
                index
              ].courseListList.slice(0, 8);
              // 小于4个，克隆
              let clist = res.data[index].courseListList;
              let len = clist.length;

              // if (Array.isArray(clist) && len < 4) {
              //   for (var i = 0; i < 4 - len; i++) {
              //     console.log(i);
              //     res.data[index].courseListList.push(
              //       res.data[index].courseListList[i]
              //     );
              //   }
              // }
            });

            this.list = res.data;
          }
        }
      );
    },
    open(index) {
      let data = this.list[index].courseListList;
      this.curTitle = this.list[index].cateName;
      if (Array.isArray(data) && data.length > 0) {
        this.partList = deepClone(data);
      } else {
        this.partList = [];
      }
      this.catePartShow = true;
    },
    close() {
      this.catePartShow = false;
      this.partList = [];
    },
    GotoCourseDetail(id, packagebagId) {
      this.$router.push({
        name: "courseDetail",
        params: {
          courseId: id,
          packagebagId,
          oldPage: 1,
          courseType: this.courseType
        }
      });
      sessionStorage.setItem("returnRouteBack", "home");
      localStorage.setItem("packagebagId", packagebagId);
      localStorage.setItem("courseId", id);
      localStorage.setItem("courseType", this.courseType);
    }
  }
};
</script>

<style lang="less"  src="./public.less" scoped></style>
<style lang="less" scoped>
.courser-card {
  width: 1200px;
  margin: 20px auto 0;
  padding: 0 21px;
  box-sizing: border-box;
  background: #fff;
  .home2-title {
    position: relative;
    background-image: url("../../../../static/home2.0/icon-couser.png");
    display: flex;
    .title-cate {
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      align-items: center;
      margin-left: 28px;
      width: 750px;
      a {
        font-size: 14px;
        font-weight: bold;
        margin-right: 29px;
        color: #666;
        &:hover {
          color: #3482ff;
        }
      }
    }
    .more {
      display: block;
      position: absolute;
      right: 0;
      top: 0;
      color: #666;
      font-size: 16px;
      padding-right: 20px;
      font-weight: normal;
      background: url("../../../../static/home2.0/icon-more.png") no-repeat
        center right;
      cursor: pointer;
      &:hover {
        color: #3482ff;
      }
    }
  }
  .courser-content {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    margin-top: 24px;
    .courser-carder {
      width: 25%;
      padding: 0 16px;
      box-sizing: border-box;
      .card-main {
        width: 100%;
        display: block;
        color: #333;
        margin-bottom: 25px;
        background: #fff;
        box-shadow: 0 0 15px 0px #eee;
        transition: all 0.2s;
        cursor: pointer;
        &:hover {
          box-shadow: 0 0 10px 5px #ddd;
        }
        .el-image {
          width: 100%;
          height: 175px;
        }
        img {
          width: 100%;
          height: 175px;
        }
        .title {
          padding: 13px 8px;
          box-sizing: border-box;
          text-align: left;
          font-size: 16px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .bottom {
          display: flex;
          justify-content: space-between;
          color: #b3b3b3;
          padding: 0 10px 10px;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Home3.0/src/CourserBox.vue